"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE_FOLDER = exports.TYPE_FILE = exports.TEAMS_SOURCE = exports.SUMMARY_STATUS_SUCCESS = exports.SUMMARY_STATUS_FAILED = exports.SOURCE_TEAMS = exports.SOURCE_MANUAL = exports.OVERRIDE_MESSAGE = exports.MAX_TXT_CHARACTERS = exports.MAX_METADATA_LENGTH = exports.MAX_FILE_UPLOAD = exports.MAX_FILES_SIZE = exports.KB_SOURCE = exports.INDEXING_STATUSES = exports.FOLDER_SOURCE_TEAMS = exports.FILE_TYPE_NO_CONVERSION = exports.CATEGORIES = exports.AlertColor = void 0;
var CATEGORIES = exports.CATEGORIES = [{
  label: "Deloitte data",
  value: "Deloitte data"
}, {
  label: "Client data",
  value: "Client data"
}, {
  label: "Third-party data",
  value: "Third-party data"
}];
var MAX_METADATA_LENGTH = exports.MAX_METADATA_LENGTH = 500;
var AlertColor = exports.AlertColor = /*#__PURE__*/function (AlertColor) {
  AlertColor["Success"] = "success";
  AlertColor["Error"] = "error";
  AlertColor["Warning"] = "warning";
  AlertColor["Info"] = "info";
  return AlertColor;
}({});
var KB_SOURCE = exports.KB_SOURCE = "knowledgebase";
var TEAMS_SOURCE = exports.TEAMS_SOURCE = "teams";
var MAX_TXT_CHARACTERS = exports.MAX_TXT_CHARACTERS = 1000000; // 1 million characters

var TYPE_FOLDER = exports.TYPE_FOLDER = "folder";
var TYPE_FILE = exports.TYPE_FILE = "file";
var FOLDER_SOURCE_TEAMS = exports.FOLDER_SOURCE_TEAMS = "teams";
var INDEXING_STATUSES = exports.INDEXING_STATUSES = {
  IN_PROGRESS: "Processing",
  SUCCESS: "Success",
  NOT_FOUND: "Not Found",
  ERROR: "Error"
};
var MAX_FILES_SIZE = exports.MAX_FILES_SIZE = 100;
var MAX_FILE_UPLOAD = exports.MAX_FILE_UPLOAD = 25;
var OVERRIDE_MESSAGE = exports.OVERRIDE_MESSAGE = "This file already exists, uploading will override the current version.";
var SOURCE_MANUAL = exports.SOURCE_MANUAL = "Manual Upload";
var SOURCE_TEAMS = exports.SOURCE_TEAMS = "Teams Import";
var SUMMARY_STATUS_SUCCESS = exports.SUMMARY_STATUS_SUCCESS = "success";
var SUMMARY_STATUS_FAILED = exports.SUMMARY_STATUS_FAILED = "failed";
var FILE_TYPE_NO_CONVERSION = exports.FILE_TYPE_NO_CONVERSION = ["pdf", "xls", "xlsx", "csv"];